module.exports = __webpack_public_path__ + "static/media/startup-photos.4924887e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/003_ui/startup-photos.jpg
// module id = 770
// module chunks = 0